const compare = (a, b) => {
  return a > b ? 1 : a < b ? -1 : 0;
};

const sortTableResult = (array, property, desc) => {
  return array.sort((a, b) =>
    desc ? compare(b[property], a[property]) : compare(a[property], b[property]),
  );
};

export default sortTableResult;
